import React from 'react';
import Box from '@mui/material/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import ErrorImg from '../../assets/500-internal-server-error.svg';

const ErrorDialog = ({
  description = 'К сожалению, что-то пошло не так. ' +
    'Пожалуйста, повторите попытку позднее. ' +
    'Если ошибка повторяется не первый раз, ' +
    'обратитесь к администратору сайта на it@gold-race.org.',
  isErrorDialog,
  setErrorDialog,
}) => {
  return (
    <Dialog
      open={isErrorDialog}
      onClose={() => setErrorDialog(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'Ошибка'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {description}
        </DialogContentText>
        <Box component="div" sx={{ display: 'flex', justifyContent: 'center' }}>
          <img
            alt="Изображение ошибки"
            src={ErrorImg}
            style={{ width: '400px' }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setErrorDialog(false)}
        >
          Хорошо
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
